import React from 'react';

import { imgUrl } from '../../utils/url';
import { useTranslation } from 'react-i18next';

const EmptyComment = ({
    isCoManagerEliteSubscription,
    teamOwnerId,
    currentUserId,
    goals
}) => {
    const teamOnweContent = !!(
        (isCoManagerEliteSubscription
            || teamOwnerId == currentUserId
            || currentUserId == goals.owner
        )
    );
    const { t } = useTranslation()
    return (
        <div className="wb-ghead-comments-details-empty">
            { teamOnweContent
                ? (
                    <div className="goal-table">
                        <div className="goal-table-row">
                            <div className="goal-table-col" style={{ width: '180px' }}>
                                <img
                                    alt="Goals acheivement fireworks"
                                    src={imgUrl('/images/goal/goals-acheivement-fireworks.png')}
                                    style={{ width: '150px' }}
                                />
                            </div>
                            <div className="goal-table-col">
                                <ol className="ul wb-fancy-box">
                                    <li>{t(`How's it moving along?`)}</li>
                                    <li>{t('How can I be a part of success?')}</li>
                                    <li>{t('Need any roadblocks cleared?')}</li>
                                    <li>{t('Need some encouragement?')}</li>
                                    <li>{t(`Let's align on the steps to get this done.`)}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="empty-comment-icons">
                            <img
                                alt="Goals acheivement fireworks"
                                src={imgUrl('/images/goal/goals-acheivement-fireworks.png')}
                                style={{ width: '150px' }}
                            />
                        </div>
                        <div className="empty-comment-text">
                            {t('Jump start the conversation and momentum on this TranslateToLocalSet!')}
                        </div>
                    </div>
                )}
        </div>
    )
}

export default EmptyComment;
